// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V22H16.5V14H7.5V22H2V2ZM8 9V6H6V9H8ZM13 9V6H11V9H13ZM16 9H18V6H16V9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 22V16H14.5V22H9.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-houses-1-filled')
export default class Houses1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'houses-1-filled',
    }
  }
}
